import { useSyncExternalStore } from "react";

const STORAGE_KEY = "researchly.matrix.rail-collapsed";

let isCollapsed =
  typeof window !== "undefined" &&
  window.localStorage.getItem(STORAGE_KEY) === "true";
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function setMatrixRailCollapsed(next: boolean) {
  isCollapsed = next;
  window.localStorage.setItem(STORAGE_KEY, String(next));
  listeners.forEach((listener) => listener());
}

// Folded state of the rail, persisted: it is a workspace preference.
export function useMatrixRailCollapsed() {
  const collapsed = useSyncExternalStore(subscribe, () => isCollapsed);
  return [collapsed, setMatrixRailCollapsed] as const;
}
